<template>
    <div style="width: 1000px;margin: 0 auto;color: #666;white-space: pre-wrap;">
        <div
            style="font-size: 18px;font-weight: bold;text-align: center;margin-bottom: 20px;"
        >用户租赁及服务协议</div>特别提醒：在承租方（本协议中称乙方）确认同意本合同之前，承租方应已清楚知悉并充分理解本产品的所有信息，同意向北京大租行科技有限公司（本协议中称甲方）申请租赁。一旦承租方在租赁网站或其他与本租赁相关的客户端接受本合同，即视为承租方已阅读本合同所有条款，并对本合同条款的含义及相应的法律后果已全部通晓并充分理解，同意接受本合同约束。
        <br>为了维护承租方的合法权益，出租方（本协议中称甲方）特别提醒承租方特别关注本合同条款中的黑体及加下划线部分，请务必仔细阅读。
        <br>
        <br>甲 方： 北京大租行科技有限公司
        <br>甲方地址： 北京市海淀区知春路108号豪景大厦B座1405室
        <br>联系方式： 010-82101099
        <br>乙 方：
        <span style="color:#333;">{{orderinfo.user_info&&orderinfo.user_info.idcard_name}}</span>
        <br>身份证号：
        <span style="color:#333;">{{orderinfo.user_info&&orderinfo.user_info.idcard_number}}</span>
        <br>收货地址：
        <span style="color:#333;">{{orderinfo.user_address&&orderinfo.user_address.address_details}}</span>
        <br>联系电话：
        <span
            style="color:#333;"
        >{{orderinfo.user_address&&orderinfo.user_address.mobile||orderinfo.user_info&&orderinfo.user_info.mobile}}</span>
        <br>
        <br>乙方确认并承诺：
        <br>1.租赁过程中填写的名称、联系方式、证件信息等准确无误，为甲方与乙方联系的唯一方式，甲方通过上述地址寄送的任何文书均视为乙方已收到该文书。对于因本协议争议引起的任何纠纷，乙方声明司法机关（包括但不限于人民法院）可以手机短信或电子邮件等现代通讯方式或邮寄方式向乙方送达法律文书（包括但不限于诉讼文书）。如有变更，将重新签署地址变更确认书并书面通知甲方。乙方承担因按照上述地址投递或变更地址而导致无法收到文书所引起的任何法律责任。
        <br>2.使用以乙方本人名义注册的且经过实名认证并设置密码的个人账户在甲方租赁平台或相关客户端所从事的所有行为均视为乙方本人行为，包括但不限于订立本合同，申请租赁等，该等行为的法律后果均由乙方本人承担。
        <br>甲乙方就乙方向甲方申请租赁产品,甲方负责对乙方的申请核实审批，并为租赁产品提供意外保障服务（详见意外保障服务条款）及咨询等客户服务事宜，经友好协商一致，签署本《用户租赁及服务协议》（下称“本协议”）。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第一条 订单信息</p>订单编号：
        <span style="color:#333;">{{orderinfo.order_number}}</span>
        <br>用户昵称：
        <span style="color:#333;">{{orderinfo.user_info&&orderinfo.user_info.nickname}}</span>
        <br>收货人：
        <span
            style="color:#333;"
        >{{orderinfo.user_address&&orderinfo.user_address.consignee||orderinfo.user_info&&orderinfo.user_info.nickname}}</span>
        <br>联系电话：
        <span
            style="color:#333;"
        >{{orderinfo.user_address&&orderinfo.user_address.mobile||orderinfo.user_info&&orderinfo.user_info.mobile}}</span>
        <br>收货地址：
        <span style="color:#333;">{{orderinfo.user_address&&orderinfo.user_address.address_details}}</span>
        <br>起租日期：
        <span style="color:#333;">{{orderinfo.start_time}}</span>
        <br>寄回日期：
        <span style="color:#333;">{{orderinfo.end_time}}</span>
        <br>租用产品名称：
        <span v-if="orderinfo.goods_info" v-for="(v,i) in orderinfo.goods_info" :key="i">
            <span style="color:#333;">{{v.goods_name+'（'+v.config_name+'）'+(i!=orderinfo.goods_info.length-1?'、':'')}}</span>
        </span>
        <br>产品SN：
        <br>配件清单：
        <span v-if="orderinfo.goods_info" v-for="(v,i) in orderinfo.goods_info" :key="i">
            <span style="color:#333;">{{v.config_configuration_list+(i!=orderinfo.goods_info.length-1&&v.config_configuration_list!=''?'、':'')}}</span>
        </span>
        <br>
        <br>本租赁产品及产品配件在租赁到期归还时，若未按约定归还的、或有损坏的，需要赔偿相应费用。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第二条 租金和支付方式</p>1.乙方向甲方提交订单之后，甲方将根据乙方选择的设备类型和租赁日期核算出租金费用。
        <br>2.乙方归还租用设备之后，乙方租用设备产生的租金费用将从乙方预交在大租行注册的账户上的押金中进行扣除，若乙方预交的押金不足以全部抵扣租金费用的，乙方应当按照大租行的要求限期支付剩余的租金费用。乙方在设备租赁期限届满前续租的，甲方将根据乙方的续租要求核算续租租金，若乙方续租前预付的押金不足以抵扣租金费用的，乙方应当按照甲方的要求限期支付剩余的租金费用并预交续租期间的设备押金。
        <br>3.免押金额度：注册了甲方大租行账户的乙方，可以参加甲方开展的各类商业活动，或者经甲方租赁平台的相关政策而取得一定的免押金额度。乙方可以分开或合并使用免押金额度，但是最高不得超过甲方大租行租赁平台规定的限度。若乙方需对设备租赁的租金费用进行结算的，乙方可以优先使用免押金额度，若免押金额度不足以抵扣所有的租金费用，就不足部分，乙方应当继续支付。
        <br>4.租赁期间，如果因乙方原因导致租赁设备遭受毁损、灭失，或者乙方故意不承担维修费用或采取其他补救措施，给甲方造成经济损失的，甲方有权立即冻结乙方的注册账户，且不退还任何押金或租金，直至乙方偿付由此而给甲方造成的经济损失为止，乙方应当继续承担设备租赁所产生的所有租金费用。
        <br>5.乙方同意，若乙方逾期不交纳续租押金的，甲方有权要求乙方停止使用租赁设备，并保留无条件收回租赁设备的权利，由此造成的任何责任或损失由乙方自行承担。
        <br>6.若设备在租赁期间由于乙方原因而严重损坏，且不在订单中约定的保修范围内的，甲方有权在提供维修的同时向乙方收取维修成本费用。
        <br>7.若设备在租赁期间由于乙方原因丢失，乙方应按订单中的应付押金金额（未免押金之前）予以支付偿还，若乙方预付的押金不足以相抵乙方因此而给甲方造成的所有经济损失的，就不足部分甲方有权向乙方继续追偿。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第三条 甲方权利及义务</p>1.甲方应按乙方订单要求发货。
        <br>2.乙方租赁下单时，即视为授权甲方使用乙方的真实身份信息通过第三方信用认证，并获得其在第三方信用认证平台的信用信息。
        <br>3.甲方应为乙方提供租赁物在租赁期间的意外保障服务，乙方应交纳意外保障服务费用。
        <br>4.甲方有权将乙方的违约行为向相关征信机构披露。
        <br>5.对于退还的租赁物，甲方将抹除所有数据，将其还原至出厂初始状态，无义务保留租赁物中的相关信息。
        <br>6.对乙方交还或寄回租赁物内的遗留物件、软件或信息等，甲方不承担保管责任，乙方应在退回租赁物前妥善处理。
        <br>7.在约定的租赁期间内，甲方享有该租赁物的出租权。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第四条 乙方权利及义务</p>1.乙方在签收租赁物及配件时，应当场拆封并检测租赁物及配件，如有不符在24小时内联系甲方处理。
        <br>2.乙方应向甲方提供真实的身份信息并授权甲方查看其在本协议约定的第三方信用认证平台的信用信息。
        <br>3.乙方应签署第三方支付代扣协议，并保证账户内有足够资金用以支付租金等各项费用。
        <br>4.乙方应保障退还时的租赁产品及配件完好，租赁期间除甲方提供的保障服务外，其余维修费用均由乙方自行提供。
        <br>5.乙方在租赁期间，不得将租赁物转售、转租给除乙方之外的第三方，仅限本人使用。
        <br>6.为保障乙方自身的隐私及信息安全，退还租赁物时应删除并注销所有相关个人信息（包括但不限于所有账户及密码），并保证无任何遗留物件。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第五条 租赁产品的交付及退还</p>交付
        <br>甲方根据乙方提交订单确认的地址交付租赁物，乙方应保证提供的收货信息（包括但不限于：收货地址、收件人、联系方式等）准确无误。租期自乙方收到租赁物次日起算。
        <br>特别提醒：乙方在订单中提供的收件信息不可变更，甲方据此送交产品并获得相应签收信息即视为乙方收到合格的租赁物，甲方完成租赁产品交付义务，乙方不得以未收到租赁物或租赁物有瑕疵为由拒绝履行本协议约定义务。
        <br>退还
        <br>乙方应在租赁期届满之前，将租赁物及相关配件寄送至甲方指定地点。
        <br>退还租赁物及其配件时，租赁物及配件损坏或丢失，赔偿金额由甲方工程师检测或原厂商维修报价单为准。
        <br>特别提醒：为了更好的保障各方的权利义务，寄送应使用顺丰速运，所产生的相关费用由乙方承担。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第六条 退订政策</p>1.最终订单所确认的用户可以发货前12小时前无条件取消订单，在发货后不能取消订单。
        <br>2.乙方于租赁期间退租的，若乙方租赁的设备并不支持租赁期间要求退租，则甲方不予返还任何已收取的租金，并有权按照本协议规定优先于乙方预付的押金中扣除，若乙方预付的押金不足以抵扣租金费用的，乙方还应承担补足的责任。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第七条 违约情形及责任</p>1. 满足以下情况之一的，该乙方将被认定为违约客户：
        <br>1）恶意损坏租用设备；
        <br>2）按约定应当归还设备，但拒不归还；
        <br>3）在租期结束前提前归还设备，但不按照协议支付租赁费用或违约金；
        <br>4）归还的设备严重损坏，且拒不按协议规定偿付维修费用或赔偿甲方损失；
        <br>5）根据甲方租赁平台的相关政策及规则所确认的违约客户的其他行为。
        <br>2. 乙方同意，对于因出现违反本协议约定内容被认定为违约客户的，甲方将有权利采取包括但不限于以下的措施：
        <br>1) 不接受违约客户的服务需求；
        <br>2) 将违约客户公司信息及相应的申请人个人信息在甲方网站公布；
        <br>3) 将违约客户公司信息及相应的申请人个人信息在互联网其他网站公布；
        <br>4) 将违约客户公司信息及相应的申请人个人信息提供给第三方机构；
        <br>5) 向公安机关报案；
        <br>6) 向法院起诉，并依照相关法律规定，报请将违约客户的身份信息及相关公司信息至中国人民共和国全国法院被执行人信息网公布。
        <br>3. 乙方同意，因甲方对违约客户采取的任何措施给违约客户带来的任何损失，均由该乙方自行承担，甲方概不负责。
        <br>4.乙方涉及违约情形的，甲方有权单方面宣布本协议提前到期，乙方无条件接受。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第八条 协议终止</p>1.本协议一经成立，即具有法律效力，各方均应严格遵守，不得擅自变更或解除。
        <br>2.租赁期满，乙方退还租赁物，经甲方完成设备检测并结算所有费用后，本协议终止。
        <br>3.各种原因导致租赁物由租转售的，且甲、乙结清所有费用后，本协议终止。
        <br>4.乙方怠于履行本协议约定的各项义务，甲方有权单方面宣布解除本协议或本协议提前到期。甲、乙方结清所有费用后，本协议终止。
        <br>5.若甲方公司解散或法院受理甲方公司破产申请，自甲方公司发布该信息日起，本协议自动终止。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第九条 争议处理</p>因本协议履行过程中引起的或与本协议相关的任何争议，双方应以友好协商的方式迅速解决，若经协商仍未解决，向甲方所在地人民法院提起诉讼，因解决争议所产生的一切费用（包括但不限于诉讼费、保全费、律师费、公共费、公证费、见证费、鉴定费、交通费等）由违约方承担。
        <br>
        <br>
        <p style="font-size:16px;font-weight: bold;">第十条 法律适用与管辖</p>本服务条款中的任何一项与中华人民共和国现行法律的强制性规定相悖时，以法律的强制规定为适用依据，除此之外，不违背法律的强制性规定的条款，继续有效。乙方和甲方一致同意，由本协议条款导致的一切乙方和甲方之间的法律纠纷，应提交至北京大租行科技有限公司住所所在地有管辖权的人民法院解决。
        <br>
        <br>甲方：北京大租行科技有限公司
        <br>甲方(签章)：
        <br>签约日期：
        <span style="color:#333;">{{orderinfo.pay_time}}</span>
        <br>
        <br>乙方：
        <span
            style="color:#333;"
        >{{orderinfo.user_info&&orderinfo.user_info.idcard_name}}</span>
        <br>乙方(签字)：
        <span
            style="color:#333;"
        >{{orderinfo.user_info&&orderinfo.user_info.idcard_name}}</span>
        <br>签约日期：
        <span style="color:#333;">{{orderinfo.pay_time}}</span>
    </div>
</template>
<script>
export default {
  props: {
    orderinfo: {
      type: "Object",
      default: {}
    }
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/rental.vue